<template>
  <div class="app-container">
    <el-form v-show="showSearch" ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
      <el-form-item label="汇总报告id" prop="reportTotalId">
        <el-input
          v-model="queryParams.reportTotalId"
          clearable
          placeholder="请输入汇总报告id"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="用户id" prop="userId">
        <el-input
          v-model="queryParams.userId"
          clearable
          placeholder="请输入用户id"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告名称" prop="reportName">
        <el-input
          v-model="queryParams.reportName"
          clearable
          placeholder="请输入报告名称"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告检测时间" prop="reportDate">
        <el-date-picker v-model="queryParams.reportDate"
          clearable
          placeholder="请选择报告检测时间"
          type="date"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="报告类型名称" prop="reportTypeName">
        <el-input
          v-model="queryParams.reportTypeName"
          clearable
          placeholder="请输入报告类型名称"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="检测机构" prop="testOrganization">
        <el-input
          v-model="queryParams.testOrganization"
          clearable
          placeholder="请输入检测机构"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="检测样本" prop="testSample">
        <el-input
          v-model="queryParams.testSample"
          clearable
          placeholder="请输入检测样本"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="检测时间" prop="testDate">
        <el-input
          v-model="queryParams.testDate"
          clearable
          placeholder="请输入检测时间"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告真实姓名" prop="testRealName">
        <el-input
          v-model="queryParams.testRealName"
          clearable
          placeholder="请输入报告真实姓名"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告性别" prop="testGender">
        <el-input
          v-model="queryParams.testGender"
          clearable
          placeholder="请输入报告性别"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告年龄" prop="testAge">
        <el-input
          v-model="queryParams.testAge"
          clearable
          placeholder="请输入报告年龄"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="住院/门诊号" prop="testAdmissionNumber">
        <el-input
          v-model="queryParams.testAdmissionNumber"
          clearable
          placeholder="请输入住院/门诊号"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="queryParams.createDate"
          clearable
          placeholder="请选择创建时间"
          type="date"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" size="mini" type="primary" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:user:add']"
          icon="el-icon-plus"
          plain
          size="mini"
          type="primary"
          @click="handleAdd"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:user:edit']"
          :disabled="single"
          icon="el-icon-edit"
          plain
          size="mini"
          type="success"
          @click="handleUpdate"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:user:remove']"
          :disabled="multiple"
          icon="el-icon-delete"
          plain
          size="mini"
          type="danger"
          @click="handleDelete"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:user:export']"
          icon="el-icon-download"
          plain
          size="mini"
          type="warning"
          @click="handleExport"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column align="center" label="${comment}" prop="id" />
      <el-table-column align="center" label="汇总报告id" prop="reportTotalId" />
      <el-table-column align="center" label="用户id" prop="userId" />
      <el-table-column align="center" label="报告名称" prop="reportName" />
      <el-table-column align="center" label="报告检测时间" prop="reportDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.reportDate, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报告类型" prop="reportType" />
      <el-table-column align="center" label="报告类型名称" prop="reportTypeName" />
      <el-table-column align="center" label="检测机构" prop="testOrganization" />
      <el-table-column align="center" label="检测样本" prop="testSample" />
      <el-table-column align="center" label="检测时间" prop="testDate" />
      <el-table-column align="center" label="报告真实姓名" prop="testRealName" />
      <el-table-column align="center" label="报告性别" prop="testGender" />
      <el-table-column align="center" label="报告年龄" prop="testAge" />
      <el-table-column align="center" label="住院/门诊号" prop="testAdmissionNumber" />
      <el-table-column align="center" label="图片识别内容" prop="ocrData" />
      <el-table-column align="center" label="创建时间" prop="createDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" class-name="small-padding fixed-width" label="操作">
        <template slot-scope="scope">
          <el-button
            v-hasPermi="['biz:user:edit']"
            icon="el-icon-edit"
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
          >修改</el-button>
          <el-button
            v-hasPermi="['biz:user:remove']"
            icon="el-icon-delete"
            size="mini"
            type="text"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :limit.sync="queryParams.pageSize"
      :page.sync="queryParams.pageNum"
      :total="total"
      @pagination="getList"
    />

    <!-- 添加或修改用户报告主记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" append-to-body width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="汇总报告id" prop="reportTotalId">
          <el-input v-model="form.reportTotalId" placeholder="请输入汇总报告id" />
        </el-form-item>
        <el-form-item label="用户id" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入用户id" />
        </el-form-item>
        <el-form-item label="报告名称" prop="reportName">
          <el-input v-model="form.reportName" placeholder="请输入报告名称" />
        </el-form-item>
        <el-form-item label="报告检测时间" prop="reportDate">
          <el-date-picker v-model="form.reportDate"
            clearable
            placeholder="请选择报告检测时间"
            type="date"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报告类型名称" prop="reportTypeName">
          <el-input v-model="form.reportTypeName" placeholder="请输入报告类型名称" />
        </el-form-item>
        <el-form-item label="检测机构" prop="testOrganization">
          <el-input v-model="form.testOrganization" placeholder="请输入检测机构" />
        </el-form-item>
        <el-form-item label="检测样本" prop="testSample">
          <el-input v-model="form.testSample" placeholder="请输入检测样本" />
        </el-form-item>
        <el-form-item label="检测时间" prop="testDate">
          <el-input v-model="form.testDate" placeholder="请输入检测时间" />
        </el-form-item>
        <el-form-item label="报告真实姓名" prop="testRealName">
          <el-input v-model="form.testRealName" placeholder="请输入报告真实姓名" />
        </el-form-item>
        <el-form-item label="报告性别" prop="testGender">
          <el-input v-model="form.testGender" placeholder="请输入报告性别" />
        </el-form-item>
        <el-form-item label="报告年龄" prop="testAge">
          <el-input v-model="form.testAge" placeholder="请输入报告年龄" />
        </el-form-item>
        <el-form-item label="住院/门诊号" prop="testAdmissionNumber">
          <el-input v-model="form.testAdmissionNumber" placeholder="请输入住院/门诊号" />
        </el-form-item>
        <el-form-item label="图片识别内容" prop="ocrData">
          <el-input v-model="form.ocrData" placeholder="请输入内容" type="textarea" />
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="form.createDate"
            clearable
            placeholder="请选择创建时间"
            type="date"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addReportUser, delReportUser, getReportUser, listReportUser, updateReportUser} from "@/api/biz/ReportUser";

export default {
  name: "ReportUser",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户报告主记录表格数据
      userList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        reportTotalId: null,
        userId: null,
        reportName: null,
        reportDate: null,
        reportType: null,
        reportTypeName: null,
        testOrganization: null,
        testSample: null,
        testDate: null,
        testRealName: null,
        testGender: null,
        testAge: null,
        testAdmissionNumber: null,
        ocrData: null,
        createDate: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询用户报告主记录列表 */
    getList() {
      this.loading = true;
      listReportUser(this.queryParams).then(response => {
        this.userList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        reportTotalId: null,
        userId: null,
        reportName: null,
        reportDate: null,
        reportType: null,
        reportTypeName: null,
        testOrganization: null,
        testSample: null,
        testDate: null,
        testRealName: null,
        testGender: null,
        testAge: null,
        testAdmissionNumber: null,
        ocrData: null,
        createDate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加用户报告主记录";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getReportUser(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改用户报告主记录";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateReportUser(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addReportUser(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除用户报告主记录编号为"' + ids + '"的数据项？').then(function() {
        return delReportUser(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biz/reportUser/export', {
        ...this.queryParams
      }, `user_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
